import { toGreek } from 'greeklish';

/** Λέξη σε greeklish (μόνο λατινικά γράμματα, μήκος >= 2) — αγνοεί αριθμούς,
 * URLs, emails κ.λπ. αφού αυτά δεν ταιριάζουν στο pattern. */
const GREEKLISH_WORD = /^[A-Za-z]{2,}$/;

/** Το πακέτο greeklish βάζει πάντα "σ" ακόμα και στο τέλος λέξης — διόρθωσέ το
 * σε τελικό "ς" όταν είναι η τελευταία λέξη πριν από κενό/σημείο στίξης ή στο
 * τέλος του string. */
function fixFinalSigma(word: string): string {
  return word.replace(/σ$/, 'ς');
}

/** Μετατρέπει μία λέξη greeklish σε ελληνικά, ΧΩΡΙΣ τόνους (σκόπιμα — λέξεις
 * όπως "poso" (πόσο/ποσό) είναι διφορούμενες χωρίς τόνο· καλύτερα να αφήνουμε
 * τον χρήστη να καταλάβει από τα συμφραζόμενα παρά να μαντεύουμε λάθος τόνο). */
export function transliterateGreeklishWord(word: string): string {
  return fixFinalSigma(toGreek(word));
}

/** Αν το κείμενο μόλις τελείωσε μια λέξη (ο χρήστης πάτησε κενό/σημείο
 * στίξης/enter) και αυτή η λέξη είναι γραμμένη σε greeklish, τη μετατρέπει σε
 * ελληνικά επί τόπου. Καλείται σε κάθε onChangeText — επιστρέφει το ίδιο
 * κείμενο αμετάβλητο αν δεν ταιριάζει καμία συνθήκη (πολύ φθηνό no-op). */
export function autoTransliterateOnWordBoundary(text: string): string {
  if (text.length === 0) return text;
  const lastChar = text[text.length - 1];
  if (!/[\s,.!?;:\n]/.test(lastChar)) return text;

  const before = text.slice(0, -1);
  const match = before.match(/([A-Za-z]+)$/);
  if (!match) return text;

  const word = match[1];
  if (!GREEKLISH_WORD.test(word)) return text;

  const converted = transliterateGreeklishWord(word);
  if (converted === word) return text;

  return before.slice(0, before.length - word.length) + converted + lastChar;
}
